module.exports = __webpack_public_path__ + "img/onboarding/first-video-47c8476b096bbdfbbd0300bc29989958.svg";